// extracted by mini-css-extract-plugin
export default {"selected_value":"TextFilterSelected_selected_value__nbjXH","icon_reset":"TextFilterSelected_icon_reset__Ob2-M","selected_text":"TextFilterSelected_selected_text__6mpWV"};